import { configureStore } from '@reduxjs/toolkit'
import { app } from 'common/ducks/index'
import createSagaMiddleware from "redux-saga";
import rootReducer from 'Redux/Reducer/index';
import rootSagas from '../Redux/Sagas/rootSaga'

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: {
    app: app.reducer,
    rootReducer
  },
  middleware: [sagaMiddleware],
  devTools: window.devToolsExtension && window.devToolsExtension(),
}
)
sagaMiddleware.run(rootSagas);
export default store;
